import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSnapshot } from 'valtio';

import { authStore, noticesStore } from 'stores/global';

import AuthPageLayout from './AuthPageLayout';

export default function LogoutPage() {
  const navigate = useNavigate();
  const { authStatus } = useSnapshot(authStore.state);

  useEffect(() => {
    if (authStatus === 'user') {
      authStore.logout();
    } else {
      noticesStore.warning(
        'You are not logged in. You will be automatically redirected',
      );
      setTimeout(() => {
        navigate('/login?redirectTo=studio');
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus]);

  return <AuthPageLayout title="Logging out" />;
}
